export default class DeleteEntityWorkTypeAssociationError extends Error {

}